<ng-container>
    <ng-container *ngIf="device?.routerInitState === ROUTER_STATE.Grace || device?.routerInitState === ROUTER_STATE.Invalid || device?.routerInitState === ROUTER_STATE.Registered">
        <!--NO Certificate or grace period-->
        <mat-icon [im2mTooltip] content-type="template" color="warn"
            >cancel
            <!-- ToolTip -->
            <im2m-tooltip-content class="tooltip">
                <div class="element" *ngFor="let item of certificateTooltipItems" [ngSwitch]="item">
                    <ng-container *ngSwitchCase="'validityPeriod'">
                        <div class="header">
                            {{ 'DEVICES.CERTIFICATES.' + (device?.certificateInfo?.certificateValidUntil ? 'certificateValidUntil' : 'grantedUntil') | uppercase | transloco }}
                        </div>
                        <div class="content">
                            {{
                                device?.certificateInfo && (device?.certificateInfo?.certificateValidUntil || device?.certificateInfo?.grantedUntil)
                                    ? ((device?.certificateInfo?.certificateValidUntil ? device?.certificateInfo?.certificateValidUntil : device?.certificateInfo?.grantedUntil)
                                      | liebherMarkAsUTC
                                      | date : ('DATE_TIME_FORMAT' | transloco))
                                    : '-'
                            }}
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <div class="header">
                            {{ 'DEVICES.CERTIFICATES.' + (item | uppercase) | transloco }}
                        </div>
                        <div class="content">
                            {{
                                device?.certificateInfo && device?.certificateInfo[item]
                                    ? item === 'grantedBy'
                                        ? device?.certificateInfo[item]
                                        : (device?.certificateInfo[item] | liebherMarkAsUTC | date : ('DATE_TIME_FORMAT' | transloco))
                                    : '-'
                            }}
                        </div>
                    </ng-container>
                </div>
            </im2m-tooltip-content></mat-icon
        >
    </ng-container>
    <ng-container *ngIf="device?.routerInitState === ROUTER_STATE.Init">
        <!--init state-->
        <mat-icon [im2mTooltip] content-type="template" color="primary"
            >watch_later
            <!-- ToolTip -->
            <im2m-tooltip-content class="tooltip">
                <div class="element" *ngFor="let item of certificateTooltipItems" [ngSwitch]="item">
                    <ng-container *ngSwitchCase="'validityPeriod'">
                        <div class="header">
                            {{ 'DEVICES.CERTIFICATES.' + (device?.certificateInfo?.certificateValidUntil ? 'certificateValidUntil' : 'grantedUntil') | uppercase | transloco }}
                        </div>
                        <div class="content">
                            {{
                                device?.certificateInfo && (device?.certificateInfo?.certificateValidUntil || device?.certificateInfo?.grantedUntil)
                                    ? ((device?.certificateInfo?.certificateValidUntil ? device?.certificateInfo?.certificateValidUntil : device?.certificateInfo?.grantedUntil)
                                      | liebherMarkAsUTC
                                      | date : ('DATE_TIME_FORMAT' | transloco))
                                    : '-'
                            }}
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <div class="header">
                            {{ 'DEVICES.CERTIFICATES.' + (item | uppercase) | transloco }}
                        </div>
                        <div class="content">
                            {{
                                device?.certificateInfo && device?.certificateInfo[item]
                                    ? item === 'grantedBy'
                                        ? device?.certificateInfo[item]
                                        : (device?.certificateInfo[item] | liebherMarkAsUTC | date : ('DATE_TIME_FORMAT' | transloco))
                                    : '-'
                            }}
                        </div>
                    </ng-container>
                </div>
            </im2m-tooltip-content></mat-icon
        >
    </ng-container>
    <ng-container *ngIf="device?.routerInitState === ROUTER_STATE.Normal || device?.routerInitState === ROUTER_STATE.CertDownload">
        <!--valid certificate-->
        <mat-icon [im2mTooltip] content-type="template" color="accent"
            >check_circle
            <!-- ToolTip -->
            <im2m-tooltip-content class="tooltip">
                <div class="element" *ngFor="let item of certificateTooltipItems" [ngSwitch]="item">
                    <ng-container *ngSwitchCase="'validityPeriod'">
                        <div class="header">
                            {{ 'DEVICES.CERTIFICATES.' + (device?.certificateInfo?.certificateValidUntil ? 'certificateValidUntil' : 'grantedUntil') | uppercase | transloco }}
                        </div>
                        <div class="content">
                            {{
                                device?.certificateInfo && (device?.certificateInfo?.certificateValidUntil || device?.certificateInfo?.grantedUntil)
                                    ? ((device?.certificateInfo?.certificateValidUntil ? device?.certificateInfo?.certificateValidUntil : device?.certificateInfo?.grantedUntil)
                                      | liebherMarkAsUTC
                                      | date : ('DATE_TIME_FORMAT' | transloco))
                                    : '-'
                            }}
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <div class="header">
                            {{ 'DEVICES.CERTIFICATES.' + (item | uppercase) | transloco }}
                        </div>
                        <div class="content">
                            {{
                                device?.certificateInfo && device?.certificateInfo[item]
                                    ? item === 'grantedBy'
                                        ? device?.certificateInfo[item]
                                        : (device?.certificateInfo[item] | liebherMarkAsUTC | date : ('DATE_TIME_FORMAT' | transloco))
                                    : '-'
                            }}
                        </div>
                    </ng-container>
                </div>
            </im2m-tooltip-content>
        </mat-icon>
    </ng-container>
    <ng-container *ngIf="device?.routerInitState === ROUTER_STATE.NormalRenewal">
        <!--renewal time-->
        <mat-icon [im2mTooltip] content-type="template" color="primary"
            >error
            <!-- ToolTip -->
            <im2m-tooltip-content class="tooltip">
                <div class="element" *ngFor="let item of certificateTooltipItems" [ngSwitch]="item">
                    <ng-container *ngSwitchCase="'validityPeriod'">
                        <div class="header">
                            {{ 'DEVICES.CERTIFICATES.' + (device?.certificateInfo?.certificateValidUntil ? 'certificateValidUntil' : 'grantedUntil') | uppercase | transloco }}
                        </div>
                        <div class="content">
                            {{
                                device?.certificateInfo && (device?.certificateInfo?.certificateValidUntil || device?.certificateInfo?.grantedUntil)
                                    ? ((device?.certificateInfo?.certificateValidUntil ? device?.certificateInfo?.certificateValidUntil : device?.certificateInfo?.grantedUntil)
                                      | liebherMarkAsUTC
                                      | date : ('DATE_TIME_FORMAT' | transloco))
                                    : '-'
                            }}
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <div class="header">
                            {{ 'DEVICES.CERTIFICATES.' + (item | uppercase) | transloco }}
                        </div>
                        <div class="content">
                            {{
                                device?.certificateInfo && device?.certificateInfo[item]
                                    ? item === 'grantedBy'
                                        ? device?.certificateInfo[item]
                                        : (device?.certificateInfo[item] | liebherMarkAsUTC | date : ('DATE_TIME_FORMAT' | transloco))
                                    : '-'
                            }}
                        </div>
                    </ng-container>
                </div>
            </im2m-tooltip-content>
        </mat-icon>
    </ng-container>
</ng-container>
